export default "__VITE_ASSET__51743330__"